import React, { useState, useEffect } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { Detail } from '@tecuity/granite-ui/Detail'
import { Spinner } from '../Loaders/Loaders'
import format from 'date-fns/format'
// import { getRecordSourceTypeIdFromFilingSourceTypeId } from '../../Utilities/Utilities'
import { FETCH_ENTITY_NOTES } from '../../requests'
import './WVMNotes.scss'

const WVMNotes = () => {
  const { selectedRow } = useSelector((state) => state.workview2, shallowEqual)
  const { appUserRights } = useSelector((state) => state.auth, shallowEqual)
  const [recordNotes, setRecordNotes] = useState([])
  const [loadingNotes, setLoadingNotes] = useState(false)

  useEffect(() => {
    if (selectedRow && selectedRow.RecordToAmend) {
      // const recordSourceTypeId = getRecordSourceTypeIdFromFilingSourceTypeId(
      //   selectedRow.SourceTypeId
      // ) This is now the RecordSourceTypeId not the FilingSourceTypeId
      if (selectedRow.SourceTypeId !== null) {
        // get notes
        setLoadingNotes(true)
        FETCH_ENTITY_NOTES(
          selectedRow.SourceTypeId,
          selectedRow.RecordToAmend.SourceID,
          (notes) => {
            setRecordNotes(notes)
            setLoadingNotes(false)
          },
          (err) => {
            setLoadingNotes(false)
            console.error(err)
          }
        )
      }
    } else {
      setRecordNotes([])
    }
  }, [selectedRow, selectedRow.RecordToAmend])

  if (!appUserRights || !appUserRights.includes('WvmViewNotes')) return null
  if (loadingNotes) return <Spinner size="small" themeColor="dark-neutral" />

  return recordNotes && recordNotes.length > 0 ? (
    <div className="wvm-notes">
      <h2>Notes</h2>
      <div className="note-word-break">
        {recordNotes.map((note, i) => {
          const parts = note.NoteText.split('\n')
          return (
            <Detail
              label={`${note.LastModifiedUser} ${format(
                new Date(note.LastModifiedDate),
                'MM/dd/yyyy hh:mm a'
              )}`}
              fontSize="small"
              key={i}
              customCss={`margin-bottom: 4px;`}
            >
              {parts.map((part, j) => {
                return (
                  <React.Fragment key={'' + note.NOTE_ID + j}>
                    {part}
                    {j !== parts.length - 1 ? <br /> : null}
                  </React.Fragment>
                )
              })}
            </Detail>
          )
        })}
      </div>
    </div>
  ) : null
}

export default WVMNotes
